module.exports = __webpack_public_path__ + "static/media/default.90f0aa20.svg";